import * as React from 'react';
import renderDataTest from '../../../utilities/testAutomation';

interface SwitchInputProps {
  options: string[];
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<any>) => void;
  dataTest: string;
}

export const SwitchInput = ({
  options,
  name,
  value,
  onChange,
  dataTest,
  ...rest
}: SwitchInputProps) => (
  <div className="input-wrapper">
    <div className="switch">
      {options.map(option => (
        <button
          className="radio-label"
          role="option"
          key={option}
          aria-selected={value === option}
          name={name}
          value={option}
          onClick={onChange}
          {...renderDataTest(dataTest, option)}
          {...rest}
        >
          {option}
        </button>
      ))}
    </div>
  </div>
);

export default SwitchInput;



// WEBPACK FOOTER //
// ./src/components/Inputs/SwitchInput/SwitchInput.tsx